module.exports = __webpack_public_path__ + "img/brown-arrow-up.b4413a06.svg";